
export class InfoObservation{
    ribbon: Map<string, number> = new Map();
    job: Map<string, number>= new Map();
    weapon: Map<string, number>= new Map();
    generalStaff: Map<string, number>= new Map();
}